import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Inject, Injectable, Output, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { Router, RouterModule } from '@angular/router';
import {
  L10N_CONFIG,
  L10N_LOCALE,
  L10nConfig,
  L10nLocale,
  L10nTranslatePipe,
  L10nTranslationService
} from 'angular-l10n';
import { APIConfigService } from "../api.config.service";
import { AngularMaterial2Module } from "../app.module.material";
import { AuthService } from './auth.service';
import { ErrorHelper } from "./error.helper";
import { HeaderComponent } from "./header.component";
import { Lieferant } from './lieferant.model';
import { LoggerService } from './logger.service';
import { MenuItem } from './menu.item';
import { Kernantwort } from './response/kernantwort.model';

@Pipe({
  name: 'orderBy',
  pure: false,
  standalone: true

})
@Injectable()
export class MenuOrderBy implements PipeTransform {
  transform(items: MenuItem[], args: string): MenuItem[] {
    return items.sort((a: MenuItem, b: MenuItem) => {
      if (a[args] < b[args]) return -1;
      else if (a[args] > b[args]) return 1;
      else return 0;
    });
  }
}

const PATH_FILE: string='app/shared/menu.component.ts';

/**
 * Beispiel von http://stackoverflow.com/questions/40620340/how-can-create-a-dynamic-menu-in-angular-2
 */
@Component({
  selector: 'oase-menu',
  templateUrl: './menu.component.html',
  standalone: true,
  imports: [AngularMaterial2Module, L10nTranslatePipe, HeaderComponent, MatSidenavModule, RouterModule, MenuOrderBy],
})
export class MenuComponent {
  pathFile: string = PATH_FILE;
  @ViewChild('sidenav', { static: false, read: MatSidenav }) sidenav: MatSidenav;
  @Output() langEmitter = new EventEmitter();
  @Output() themeEmitter = new EventEmitter();
  menuItemList: MenuItem[] = [];
  fehler: Kernantwort = null;
  lieferant: Lieferant;

  constructor(
    public authService: AuthService,
    public apiConfigService: APIConfigService, public http: HttpClient,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    @Inject(L10N_CONFIG) private config: L10nConfig,
    public translation: L10nTranslationService,
    private router: Router,
    private _logger: LoggerService) {
      this._logger.log(PATH_FILE + ' - MenuComponent constructor');
      this.getLieferantDaten();
      this.setNavigation(1);
  }

  private setNavigation(userID: number) {
    this._logger.log(PATH_FILE + ' - setNavigation Begin');
    this.authService.logTokenInfos(PATH_FILE + ' - setNavigation');
    this.http
      .get<MenuItem[]>(this.apiConfigService.REST_API_BASE() + 'navigation/liste')
      .subscribe({
        next: (data) => {
          this.menuItemList = data;
          this._logger.log(PATH_FILE + ' - setNavigation End');
        },
        error: (err) => ErrorHelper.handleError(err, "Fehler beim holen der Navigation", this._logger, this.translation),
        complete: () => this._logger.log(PATH_FILE + ' - Holen der Navigation abgeschlossen')
      });
  }

  private getLieferantDaten() {
    this._logger.log(PATH_FILE + ' - getLieferantDaten Begin');
    this.authService.logTokenInfos(PATH_FILE + ' - getLieferantDaten');
    this.http
      .get<Lieferant>(this.apiConfigService.REST_API_BASE() + 'lieferant/get')
      .subscribe({
        next: (data) => {
          this.lieferant = data;
          this._logger.log(PATH_FILE + ' - getLieferantDaten erhalten für Lieferant: ' + this.lieferant.liefernummer + ' End');
        },
        error: (err) => ErrorHelper.handleError(err, "Fehler beim holen des Lieferanten", this._logger, this.translation),
        complete: () => this._logger.log(PATH_FILE + ' - Holen des Lieferanten abgeschlossen')
      });
  }

  isAuth() {
    return this.authService.isAuthenticated();
  }

  sidenavToggle() {
    this.sidenav.open();
  }

  // Sets a new locale & currency.
  toggleTheme(isDarkTheme: boolean): void {
    this.themeEmitter.emit(isDarkTheme);
  }
}